import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";

import { campaignQuery } from "../components/campaigns/api";
import { CampaignEditor } from "../components/campaigns/CampaignEditor";

export const Route = createFileRoute("/_auth/_messaging/campaigns/$id")({
  staticData: { titleKey: "nav.messaging", breadcrumbKey: "breadcrumb.operate", breadcrumbN: 7 },
  component: CampaignDetail,
});

function CampaignDetail() {
  const { id } = Route.useParams();
  const { data: campaign, isLoading } = useQuery(campaignQuery(id));
  if (isLoading || !campaign) return <span style={{ color: "var(--fg-mute)" }}>…</span>;
  // Keyed so opening another campaign re-seeds the editor rather than keeping
  // this one's draft.
  return <CampaignEditor key={campaign.id} campaign={campaign} />;
}
